<div class="modal-dialog m-0" style="max-width: 100%; max-height: 80vh">
  <div class="modal-content" style="border: none; max-height: 80vh">
    <app-modal-header-common
      [title]="title"
      [dialogRef]="dialogRef"
    ></app-modal-header-common>
    <div class="breadcrumb-outer-container">
      <div class="breadcrumb">
        <ng-container
          *ngFor="let breadcrumb of breadCrumbData; let isLast = last"
        >
          <span
            [class.color-active]="isLast"
            [class.color-history-inactive]="!isLast"
          >
            {{ breadcrumb }}
          </span>
          <mat-icon *ngIf="!isLast" class="separator">chevron_right</mat-icon>
        </ng-container>
      </div>
      <div
        style="display: flex; font-size: 14px"
        *ngIf="
          metric_data?.portfolios?.length && data?.page === 'okr convergence'
        "
      >
        <button mat-flat-button (click)="reset()">
          <mat-icon matTooltip="Reset"> refresh </mat-icon>
        </button>
      </div>
      <div
        style="display: flex; margin-top: 5px"
        *ngIf="
          metric_data?.portfolios?.length && data?.page === 'balance scorecard'
        "
      >
        <span
          class="metric-box-properties status-green ml-1"
          matTooltip="On Track"
        >
          {{ getFormattedValue(metric_data?.on_track_value) }}
        </span>
        |
        <span
          class="metric-box-properties status-amber ml-1"
          matTooltip="Off Track"
        >
          {{ getFormattedValue(metric_data?.off_track_value) }}
        </span>
        |
        <span
          class="metric-box-properties status-red ml-1"
          matTooltip="At Risk"
        >
          {{ getFormattedValue(metric_data?.at_risk_value) }}
        </span>
      </div>
    </div>
    <div class="goal" *ngIf="data?.page === 'okr convergence'">
      <img src="assets/Icons/goal.svg" width="20px" />
      <span class="goal-name"> {{ data?.goal_name }} </span>
    </div>
    <app-loading *ngIf="!isDataLoaded"></app-loading>
    <!-- whatif-balance-scorecard -->
    <ng-container *ngIf="metric_data?.metric_name && isDataLoaded; else noData">
      <div
        class="metric-display d-flex justify-content-between align-items-center"
      >
        <div class="metric-header-name">
          {{ metric_data?.display_name }}
        </div>
        <div
          class="metric-box"
          [ngClass]="getHeaderStatus(getMetricStatusColor(null))"
        >
          <h1 class="m-0">
            {{ getFormattedValue(averageValue.toFixed(1)) }}
          </h1>
        </div>
        <span class="fs-4 me-auto" style="font-size: 20px">
          <app-metrics-icon
            [unit_name]="this.metric_data?.metric_unit_id?.name"
          ></app-metrics-icon>
        </span>
        <div
          class="actions d-flex align-items-center"
          *ngIf="metric_data?.metric_name && isDataLoaded"
        >
          <button mat-flat-button (click)="reset()">
            <mat-icon matTooltip="Reset" style="padding-right: 0px !important">
              refresh
            </mat-icon>
          </button>
        </div>
      </div>
      <div class="contrib-project-title" style="margin-top: 10px">
        Contributing {{ displayLabels?.project | titlecase }}s
      </div>
      <div class="whatif-body-balance-scorecard">
        <div style="flex: 1 1 auto; overflow-y: auto; padding: 0 1rem">
          <div class="metrics-container">
            <div
              *ngFor="let portfolio of metric_data.portfolios"
              class="portfolio"
            >
              <div
                *ngFor="let sub of portfolio.sub_portfolios"
                class="sub-portfolio"
              >
                <div *ngFor="let program of sub.programs" class="program">
                  <div *ngFor="let project of program.projects" class="project">
                    <input
                      type="checkbox"
                      [checked]="project.checked"
                      (change)="onProjectCheckboxChange(project, $event)"
                      class="me-2"
                    />
                    <span
                      class="project-name"
                      [matTooltip]="
                        portfolio?.display_name +
                        ' | ' +
                        sub?.display_name +
                        ' | ' +
                        program?.name
                      "
                      matTooltipPosition="above"
                      matTooltipClass="custom-tooltip-right"
                    >
                      {{ project?.name }}
                    </span>

                    <!-- Metric Value Box -->
                    <span
                      class="project-level-value"
                      [ngClass]="
                        project?.metric_value?.status === 'red'
                          ? 'status-red'
                          : project?.metric_value?.status === 'green'
                          ? 'status-green'
                          : project?.metric_value?.status === 'amber'
                          ? 'status-amber'
                          : 'status-gray'
                      "
                    >
                      {{ getFormattedValue(project?.metric_value?.value) }}
                    </span>

                    <!-- Bar -->
                    <div
                      class="bar-container mx-2"
                      [matTooltip]="
                        project?.metric_value?.value | appFormat : 'float'
                      "
                      matTooltipPosition="above"
                    >
                      <div
                        class="bar"
                        [style.width.%]="
                          calculateBarLength(project?.metric_value?.value)
                        "
                        [ngClass]="{
                          'checked-bar': project.checked,
                          'unchecked-bar': !project.checked
                        }"
                      ></div>
                    </div>

                    <!-- Controls -->
                    <div class="metric-controls ms-2">
                      <button
                        class="btn decrement"
                        (click)="
                          updateMetric(
                            project,
                            project?.metric_value?.value - 5
                          )
                        "
                      >
                        −
                      </button>
                      <button
                        class="btn increment"
                        (click)="
                          updateMetric(
                            project,
                            project?.metric_value?.value + 5
                          )
                        "
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- whatif-okr-convergence -->
    <ng-container
      *ngIf="
        metric_data?.portfolios?.length &&
          isDataLoaded &&
          data?.page === 'okr convergence';
        else noDataGoal
      "
    >
      <div class="metric-part-title" style="margin-top: 15px">
        <mat-icon class="metrics-list-indicator">bar_chart</mat-icon
        >Contributing Metrics
      </div>
      <!-- Header: metric names + averages -->
      <div
        class="metric-display d-flex justify-content-flex-start align-items-center flex-wrap mb-2"
        style="padding-right: 12px"
      >
        <div
          class="d-flex align-items-center flex-direction-column flex-wrap w-100"
        >
          <div
            *ngFor="let summary of metric_summaries; let i = index"
            class="d-flex align-items-center justify-content-between w-100 mb-1"
          >
            <div class="d-flex align-items-center">
              <span class="circle-number">{{ i + 1 }}</span>
              <div class="metric-header-name-goal">
                {{ summary.display_name }}
              </div>
              <div
                class="metric-box"
                [ngClass]="getHeaderStatus(summary.status)"
              >
                <h1 class="m-0" style="font-size: 15px">
                  {{ getFormattedValue(summary.averageValue.toFixed(1)) }}
                </h1>
              </div>
              <span class="fs-4" style="font-size: 15px !important">
                <app-metrics-icon
                  [unit_name]="summary.unit.name"
                ></app-metrics-icon>
              </span>
            </div>
            <div class="d-flex" style="margin-right: 10px">
              <span
                class="metric-box-properties status-green ml-1"
                matTooltip="On Track"
              >
                {{ getFormattedValue(summary?.on_track_value) }}
              </span>
              |
              <span
                class="metric-box-properties status-amber ml-1"
                matTooltip="Off Track"
              >
                {{ getFormattedValue(summary?.off_track_value) }}
              </span>
              |
              <span
                class="metric-box-properties status-red ml-1"
                matTooltip="At Risk"
              >
                {{ getFormattedValue(summary?.at_risk_value) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="contrib-project-title">Contributing {{displayLabels?.project | titlecase}}s</div>
      <!-- Project hierarchy -->
      <div class="whatif-body-okr-convergence">
        <div style="flex: 1 1 auto; overflow-y: auto; padding: 0 1rem">
          <div class="metrics-container">
            <div
              *ngFor="let portfolio of metric_data.portfolios"
              class="portfolio"
            >
              <div
                *ngFor="let sub of portfolio.sub_portfolios"
                class="sub-portfolio"
              >
                <div *ngFor="let program of sub.programs" class="program">
                  <div
                    *ngFor="
                      let project of program.projects;
                      trackBy: trackByProject
                    "
                    class="project-metric-stacking"
                  >
                    <!-- Project Checkbox and Name -->
                    <div class="project-header d-flex align-items-center w-100">
                      <input
                        type="checkbox"
                        [checked]="project.checked"
                        (change)="onProjectCheckboxChangeGoal(project, $event)"
                        class="me-2"
                      />
                      <span
                        class="project-name"
                        [matTooltip]="
                          portfolio?.display_name +
                          ' | ' +
                          sub?.display_name +
                          ' | ' +
                          program?.name
                        "
                        matTooltipPosition="right"
                      >
                        {{ project?.name }}
                      </span>
                    </div>

                    <!-- Metrics stacked vertically -->
                    <div class="project-metrics w-100">
                      <div
                        *ngFor="
                          let metric of project.metrics;
                          trackBy: trackByMetric
                        "
                        class="d-flex align-items-center mb-1 w-100"
                      >
                        <span
                          *ngIf="
                            metricIndexMap.get(
                              metric.display_name
                            ) as metricIndex
                          "
                          class="circle-number"
                        >
                          {{ metricIndex }}
                        </span>
                        <!-- Metric value box -->
                        <span
                          class="project-level-value"
                          [ngClass]="
                            metric.status === 'red'
                              ? 'status-red'
                              : metric.status === 'green'
                              ? 'status-green'
                              : metric.status === 'amber'
                              ? 'status-amber'
                              : 'status-gray'
                          "
                        >
                          {{ getFormattedValue(metric.value) }}
                        </span>

                        <!-- Bar -->
                        <div
                          class="bar-container mx-2 flex-grow-1"
                          [matTooltip]="metric.display_name"
                          matTooltipPosition="above"
                        >
                          <div
                            class="bar"
                            [style.width.%]="metric?.barLength"
                            [ngClass]="{
                              'checked-bar': project.checked,
                              'unchecked-bar': !project.checked
                            }"
                          ></div>
                        </div>

                        <!-- Increment/Decrement -->
                        <div class="metric-controls ms-2">
                          <button
                            class="btn decrement"
                            (click)="
                              updateMetricGoal(
                                project,
                                metric,
                                metric.value - 5
                              )
                            "
                          >
                            −
                          </button>
                          <button
                            class="btn increment"
                            (click)="
                              updateMetricGoal(
                                project,
                                metric,
                                metric.value + 5
                              )
                            "
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noData>
      <div
        *ngIf="isDataLoaded && data?.page === 'balance scorecard'"
        class="noData"
      >
        {{ staticText.common.no_records_found }}
      </div>
    </ng-template>
    <ng-template #noDataGoal>
      <div
        *ngIf="isDataLoaded && data?.page === 'okr convergence'"
        class="noData"
      >
        {{ staticText.common.no_records_found }}
      </div>
    </ng-template>
    <div class="whatif-modal-footer">
      <button
        (click)="dialogClose()"
        mat-button
        color="primary"
        class="mx-2 my-1"
      >
        Close
      </button>
    </div>
  </div>
</div>
